<template>
  <div class="smaller-container-wrapper">
    <VerifyPhoneNumberForm
      @form-successfully-submitted="handleSuccessfulSubmission"
      @form-unsuccessfully-submitted="handleFailedSubmission"
    />
  </div>
</template>

<script>
import VerifyPhoneNumberForm from '@/components/shared/VerifyPhoneNumberForm.vue';

export default {
  name: 'MobileVerification',
  components: {
    VerifyPhoneNumberForm,
  },
  methods: {
    handleSuccessfulSubmission() {
      this.$router.push({ path: this.getNextRoutePath() });
    },
    handleFailedSubmission() {
      this.$router.push('error');
    },
  },
};
</script>
